import React, { useEffect, useState } from "react";
import "./Transaction_History.css";
import Section_Header_Bar from "../../common_components/section_header_bar/Section_Header_Bar";
import Select, { components } from "react-select";
import { Form, Table } from "react-bootstrap";
import Inner_Footer_Text_Component from "../../common_components/inner_footer_text_component/Inner_Footer_Text_Component";
import No_Transaction_Matches_Lottie from "../../animation/no_transaction_matches_lottie/No_Transaction_Matches_Lottie";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSortDown } from "@fortawesome/free-solid-svg-icons";
import { getTransactionHistory } from "../../../utils/apis/transaction_history/transaction_history";
import CustomPaginate from "../../common_components/custompaginate/CustomPaginate";
import { AllTransactionType } from "../../../utils/apis/master/Master";
import { Controller } from "react-hook-form";

const Transaction_History = () => {
  const options = [
    { value: "chocolate", label: "Chocolate" },
    { value: "strawberry", label: "Strawberry" },
    { value: "vanilla", label: "Vanilla" },
  ];

  const DropdownIndicator = (props) => {
    return (
      <components.DropdownIndicator {...props}>
        <FontAwesomeIcon icon={faSortDown} className="custom_dropdown_icon" />
      </components.DropdownIndicator>
    );
  };

  const [transactionHistory, setTransactionHistory] = useState({});
  const [searchTransactionType, setSearchTransactionType] = useState("");
  const [from, setFrom] = useState("");
  const [to, setTo] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(10); // Default items per page
  const [name, setName] = useState("");

  const getHistory = async (name, page, perPage) => {
    const res = await getTransactionHistory(
      name,
      searchTransactionType,
      from,
      to,
      page,
      perPage
    );
    if (res?.success) {
      setTransactionHistory(res.data);
    }
  };

  const handlePageChange = async (page) => {
    setCurrentPage(page);
    await getHistory(name, page, perPage);
  };

  useEffect(() => {
    getHistory(name, currentPage, perPage);
  }, [name, currentPage, perPage, searchTransactionType, from, to]);
  const [transactionType, setTransactionType] = useState([]);

  const getTransactionType = async () => {
    const res = await AllTransactionType();
    if (res?.success) {
      setTransactionType(res.data.data);
    }
  };

  useEffect(() => {
    getTransactionType();
  }, []);

  return (
    <section className="Transaction_History">
      <div className="header_div">
        <Section_Header_Bar />
      </div>

      <p className="section_title">Transaction History</p>

      <div className="inner_section_box">
        <div className="inner_box">
          <div className="box_div">
            <div className="filter_div">
              <Form className="form_field_holder">
                <div className="row align-items-end">
                  <div className="col-md-3">
                    <Form.Label>Select Transaction Type</Form.Label>
                    <Select
                      options={transactionType.map((type) => ({
                        value: type.id,
                        label: type.name,
                      }))}
                      onChange={(selectedOption) =>
                        setSearchTransactionType(
                          selectedOption ? selectedOption.value : ""
                        )
                      }
                      isClearable
                      className="filter_select"
                      placeholder="All Transaction Types"
                      components={{ DropdownIndicator }}
                      value={
                        searchTransactionType
                          ? {
                              value: searchTransactionType,
                              label:
                                transactionType.find(
                                  (type) => type.id === searchTransactionType
                                )?.name || "",
                            }
                          : null
                      }
                    />
                  </div>
                  <div className="col-md-3">
                    <Form.Label>Start Date</Form.Label>
                    <Form.Control
                      type="date"
                      className="form-control filter_select"
                      value={from}
                      onChange={(e) => setFrom(e.target.value)}
                    />
                  </div>
                  <div className="col-md-3">
                    <Form.Label>End Date</Form.Label>
                    <input
                      type="date"
                      className="form-control filter_select"
                      value={to}
                      onChange={(e) => setTo(e.target.value)}
                    />
                  </div>
                  <div className="col-md-3">
                    <div
                      className="reset-button btn btn-warning"
                      onClick={() => {
                        setSearchTransactionType("");
                        setFrom("");
                        setTo("");
                      }}
                      style={{
                        cursor: "pointer",
                        color: "#000",
                        marginTop: "10px",
                        fontWeight: 600,
                      }}
                    >
                      Reset
                    </div>
                  </div>
                </div>
              </Form>
            </div>

            <div className="table-responsive table_holder">
              <Table>
                <thead>
                  <tr>
                    <th>Sr.No</th>
                    <th>Transaction Type</th>
                    <th>Amount</th>
                    <th>Admin Commission</th>
                    <th>Date</th>
                    <th>Time</th>

                    {/* <th>Quantity</th> */}
                    <th>Status</th>
                  </tr>
                </thead>

                <tbody>
                  {transactionHistory?.data?.length > 0 ? (
                    transactionHistory?.data.map((val, index) => (
                      <tr key={index}>
                        <td>
                          {(transactionHistory?.current_page - 1) *
                            transactionHistory?.per_page +
                            index +
                            1}
                        </td>

                        <td>{val?.TransactionType?.name}</td>
                        <td>$ {val?.amount}</td>
                        <td>$ {val?.DepositRequest?.admin_commission || 0}</td>
                        <td>
                          {new Date(val?.createdAt).toLocaleDateString("en-GB")}
                        </td>
                        <td>
                          {new Date(val?.createdAt).toLocaleTimeString(
                            "en-US",
                            { hour: "2-digit", minute: "2-digit", hour12: true }
                          )}
                        </td>
                        {/* <td> {val?.MoneyType?.name} </td> */}
                        {/* <td> {val?.quantity || "-"} </td> */}
                        <td> {val?.WithdrawStatus?.name || "-"} </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="18" className="text-center fw-bold">
                        <div className="no_data_div">
                          <div className="lottie_container">
                            <No_Transaction_Matches_Lottie />
                          </div>
                          <p className="no_data_text">No Transaction Found </p>
                        </div>
                      </td>
                    </tr>
                  )}
                </tbody>
              </Table>

              <CustomPaginate
                currentPage={transactionHistory?.current_page}
                totalPages={transactionHistory?.total_pages}
                handlePageChange={handlePageChange}
              />
            </div>
          </div>
        </div>

        <div className="footer_text">
          <Inner_Footer_Text_Component />
        </div>
      </div>
    </section>
  );
};

export default Transaction_History;
